import React, { Fragment, useRef } from 'react';
import { ToastProvider } from 'react-toast-notifications';
import { Row, Form } from 'react-bootstrap';
import language from '../../config/es';
import { es_entero, es_vacio } from '../../config/validate';
//redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import app from '../../config/application';
import {
  getPermissions,
  findRawChannels,
  updateChannel,
  saveChannel,
  deleteChannel,
} from '../../redux/channel.duck';
import { findBySocieties } from '../../redux/branch.duck';
import { findCountries } from '../../redux/society.duck';
import { findByConcept } from '../../redux/channelEntityPayment.duck';
//Permissions
import dictionary from '../../config/dictionary';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  usePermissionGate,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  fetchRows,
  renderDeleteAction,
  requireSelection,
  saveActionOf,
} from '../../components/Crud/crudHelpers';
import {
  CountrySelect,
  RequiredFieldsAlertLegacy,
  SelectField,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudLoadingScreen,
  CrudPage,
} from '../../components/Crud/CrudLayout';

const Channel = () => {
  //#region  variables
  const ref = useRef();
  const dispatch = useAppDispatch();

  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
    reloadWith,
    finishDelete,
  } = useCrudState({
    collectionEntity: { value: 0, label: '', error: '' },
    country: { value: 0, label: '', error: '', auth: '' },
    typeChannel: { value: 0, label: '', error: '' },
    quantityVoucher: { value: '0', error: '' },
    showloadingEntity: true,
    showloadingCountry: false,
    showloadingType: false,
    pendingData: false,
    enable: false,
    dataRows: [],
    errors: [],
    columns: [],
    entities: [],
    countries: [],
    types: [],
    selectedRows: [],
    id: null,
    showDelete: false,
    action: dictionary.configApp.action,
    auth: JSON.parse(sessionStorage.getItem('user')),
  });
  data.country.auth = useSelector((store) => store.branchReducer.errorResponse);
  data.countries = useSelector((store) => store.societyReducer.countries);
  data.types = useSelector((store) => store.typeReducer.types);
  data.entities = useSelector(
    (store) => store.collectingEntityReducer.cEntities
  );
  data.dataRows = useSelector((store) => store.channelReducer.channels);
  //#endregion
  //ciclo de vida ---------------------------------------------------
  const { loadInit, msgRestricted, withPermission } = usePermissionGate({
    ref,
    data,
    dispatch,
    getPermissions,
    notify: viewNotification,
    onAllowed: () => {
      initColumns();
      void initData();
    },
  });
  //#region functions
  const initData = async () => {
    await loadCountries();
    await loadTypes();
    data.enable = true;
    data.showloadingType = true;
    refreshState();
  };
  const loadCountries = async () => {
    await dispatch(findCountries(data.auth.id.user.userId));
    data.showloadingCountry = true;
  };
  const loadTypes = async () => {
    await dispatch(findByConcept(app.data.types.channel));
    updateState(true, 'showloadingType');
  };
  const loadEntities = async () => {
    data.showloadingEntity = false;
    await dispatch(findBySocieties(data.country.value));
    updateState(true, 'showloadingEntity');
  };
  const initColumns = () => {
    data.columns = [
      {
        name: language.messages.channel.lblChannel,
        sortable: false,
        wrap: true,
        width: '25%',
        cell: (row) => (
          <span>
            <div className=" text-uppercase small">{row.type.name}</div>
          </span>
        ),
      },
      {
        name: language.messages.channel.lblCod,
        sortable: false,
        wrap: true,
        width: '25%',
        cell: (row) => (
          <span>
            <div className=" text-uppercase text-primary small">
              {row.type.code}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.channel.lblCant,
        sortable: false,
        wrap: true,
        width: '25%',
        cell: (row) => (
          <span>
            <div className=" text-uppercase text-primary small">
              {row.quantityItem}
            </div>
          </span>
        ),
      },
      buildEditColumn(handleButtonEdit, { width: '10px' }),
    ];
    refreshState();
  };
  const handleButtonEdit = async (row) => {
    data.id = row.id;
    data.quantityVoucher.value = row.quantityItem;
    data.typeChannel.value = row.type.id;
    data.typeChannel.label = row.type.name;

    updateState(row.id, 'id');
  };
  const updateSelect = async (value, id) => {
    switch (id) {
      case 'collectionEntity':
        data.collectionEntity = value;
        data.pendingData = true;
        await loadChannels();
        data.pendingData = false;
        initColumns();
        break;
      case 'country':
        data.country = value;
        data.collectionEntity = { value: 0, label: '', error: '', auth: '' };
        data.dataRows = [];
        updateState(false, 'showloadingEntity');
        await loadEntities();
        data.showloadingEntity = true;
        initColumns();
        break;
      case 'typeChannel':
        data.typeChannel = value;
        break;
      default:
        break;
    }
    refreshState();
  };
  const onChange = (event) => {
    data.quantityVoucher.value = event.target.value;
    refreshState();
  };
  const clearForm = () => {
    data.typeChannel = { value: 0, label: '', error: '' };
    data.quantityVoucher = { value: '0', error: '' };
    data.id = null;
    refreshState();
  };
  const clearError = () => {
    data.errors = [];
    data.country.error = '';
    data.collectionEntity.error = '';
    data.typeChannel.error = '';
  };
  const cleaningForm = () => {
    clearError();
    clearForm();
    viewNotification(language.messages.success_clean_data, 'success');
  };
  const validate = () => {
    clearError();
    requireSelection(data, ['country', 'collectionEntity', 'typeChannel']);
    if (
      es_vacio(data.quantityVoucher.value) ||
      !es_entero(data.quantityVoucher.value)
    ) {
      data.errors.push('quantityVoucher.error');
      data.quantityVoucher.error = language.messages.error_numero;
    }
    refreshState();
  };

  const handleSaveResponse = async (response) => {
    if (response.status === 200) {
      if (response.data === 'EXIST') {
        updateState(true, 'enable');
        viewNotification(language.messages.msmExistRegister, 'warning');
        data.quantityVoucher = { value: '0', error: '' };
      } else {
        updateState(true, 'pendingData');
        await reloadData();
        viewNotification(
          language.messages.msmRegisterSuccessFully,
          'success'
        );
        clearError();
        clearForm();
        updateState(false, 'pendingData');
      }
    } else {
      updateState(true, 'enable');
      viewNotification(response.messageResponse, 'error');
    }
  };

  const saveData = async () => {
    validate();
    if (data.errors.length === 0) {
      updateState(false, 'enable');
      await withPermission(saveActionOf(data), async () => {
        let json = {
          id: data.id,
          status: 1,
          centity: { id: data.collectionEntity.value },
          type: { id: data.typeChannel.value },
          userAdmin: sessionStorage.getItem('username'),
          societyId: data.country.value.toUpperCase(),
          quantityItem: data.quantityVoucher.value,
        };

        let response = '';
        if (data.id === null) {
          response = await dispatch(saveChannel(json));
        } else {
          response = await dispatch(updateChannel(json));
        }

        await handleSaveResponse(response);
      });
    }
  };
  const disableData = async () => {
    if (data.selectedRows.length > 0) {
      await withPermission(data.action.delete, async () => {
        initStateDelete(false);
        let response = await dispatch(deleteChannel(data.selectedRows));
        finishDelete(
          response.status === 200,
          language.messages.msmErrorServer,
          reloadData
        );
      });
    }
  };
  const loadChannels = async () => {
    updateState(true, 'pendingData');
    data.dataRows = await fetchRows(
      () => dispatch(findRawChannels(data.collectionEntity.value)),
      viewNotification
    );

    updateState(false, 'pendingData');
  };
  const reloadData = () => reloadWith(loadChannels);
  const reloadDataEnable = () => {
    void loadChannels();
  };
  const contextActions = renderDeleteAction(disableData, data.enable);
  //#endregion
  return (
    <Fragment>
      <SessionConfig ref={ref} />
      {loadInit === true ? (
        <CrudLoadingScreen msgRestricted={msgRestricted} />
      ) : (
        <CrudPage
          top={<br />}
          formCol={{ sm: 12, md: 6, lg: 5, xl: 4 }}
          formTitle={language.messages.channel.title}
          form={
            <Form autoComplete="off">
              <RequiredFieldsAlertLegacy />
              <CountrySelect
                data={data}
                col={{ md: 12 }}
                className="text-uppercase small text-primary"
                onChange={updateSelect}
              />
              <SelectField
                row
                col={{ md: 12 }}
                label={language.messages.titleCEntityForm}
                loading={data.showloadingEntity}
                isDisabled={data.id !== null}
                name="collectionEntity"
                options={data.entities}
                className="text-uppercase small "
                field={data.collectionEntity}
                showAuth
                onChange={updateSelect}
                changeKey="collectionEntity"
              />
              <Row className="align-items-end">
                <SelectField
                  col={{ md: 6, sm: 12 }}
                  label={language.messages.channel.lblChannel}
                  loading={data.showloadingType}
                  isDisabled={data.id !== null}
                  name="typeChannel"
                  options={data.types}
                  className="text-uppercase small "
                  field={data.typeChannel}
                  onChange={updateSelect}
                  changeKey="typeChannel"
                />
                <TextField
                  col={{ md: 6, sm: 12 }}
                  label={language.messages.labelQuantityVoucher}
                  name="quantityVoucher"
                  maxLength="4"
                  field={data.quantityVoucher}
                  onChange={onChange}
                />
              </Row>
              <CrudButtons
                data={data}
                withLoading
                wrapped
                primary
                reloadIcon="fa-refresh"
                onSave={saveData}
                onClear={cleaningForm}
                onReload={reloadDataEnable}
              />
            </Form>
          }
          tableCol={{ sm: 12, md: 6, lg: 7, xl: 8 }}
          tableTitle={language.messages.channel.titleList}
          table={
            <CrudDataTable
              data={data}
              noHeader={es_vacio(data.collectionEntity.label)}
              title={
                language.messages.titleCEntityForm +
                ': ' +
                data.collectionEntity.label
              }
              rows={data.dataRows}
              scrollHeight="500px"
              onSelect={handleSelectRow}
              actions={contextActions}
            />
          }
        />
      )}
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <Channel />
  </ToastProvider>
);
export default App;
